export const selectToken = (state: any) => state.tokenStore;
